import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CommonCheckbox } from '../CommonCheckbox';

import { IShippingInfo } from '@src/pages/checkout/components/ShippingInformation/types';
import { CountryService } from '@global/utils/CountryService';
import { store } from '@global/store/store';
import { RootState } from '@global/store/store';

import './styles.scss';

interface ExistingAddressProps {
  isSelected: boolean;
  onSelect: () => void;
  address: IShippingInfo;
}

export const ExistingAddress: FC<ExistingAddressProps> = ({
  isSelected,
  onSelect,
  address,
}) => {
  const { t } = useTranslation('', { keyPrefix: 'activeForm' });
  const { country: countryState } = store.getState() as RootState;

  const country = address?.country?.iso2Code
    ? CountryService.getCountryByIsoCode(
        countryState.countries,
        address.country.iso2Code
      )
    : undefined;

  const displayState =
    country && address?.state
      ? CountryService.convertChinaStateCodeForDisplay(country, address.state)
      : address?.state;

  return (
    <address className="existing-address">
      <CommonCheckbox checked={isSelected} toggle={onSelect} />
      <div>
        <span className="existing-address__title">{t('sameAsShipping')}</span>
        {isSelected && (
          <ul className="existing-address__list">
            <li className="existing-address__item">
              {address.firstName} {address.lastName}
            </li>
            <li className="existing-address__item">
              {address.addressOne} {address.addressTwo}
            </li>
            <li className="existing-address__item">
              {address.city}, {displayState} {address.zip}
            </li>
            <li className="existing-address__item">{address.country.name}</li>
            <li className="existing-address__item">{address.phone}</li>
          </ul>
        )}
      </div>
    </address>
  );
};
